import React, {useCallback} from 'react';
import {Tooltip, Popconfirm, Button, Modal, Spin} from 'antd';
import ViewportDropdown from '../ViewportPopup/ViewportDropdown';
import {
  EditOutlined,
  CopyOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  FormOutlined,
  ExportOutlined,
  SaveOutlined,
  SendOutlined,
  EyeOutlined,
  PlusOutlined,
  UploadOutlined,
  FileTextOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import UpdateHistoryTableInfo from '../../AdminComponents/HistoryView';
import AuditLogModalTrigger from '../../AdminComponents/HistoryView/AuditLogModalTrigger';
import {useNavigate} from 'react-router-dom';
import {CREATE, READ, UPDATE, DELETE} from '../../../Constant/enums';
import {usePermissions} from '../../../hooks/usePermission';
import useLocalization from '../../../Localization';
const AUDIT_LOG_RESOURCES = new Set([
  'events',
  'events_options',
  'events_refund',
  'events_email_scheduler',
  'coupon_codes',
]);

const getAuditLogText = (resource, text) => {
  if (resource === 'events_registrations') {
    return 'Event Registration';
  }
  if (resource === 'events_refund') {
    return 'Event Refund';
  }
  if (resource === 'events_email_scheduler') {
    return 'Event Template Scheduler';
  }
  if (resource === 'coupon_codes') {
    return 'Coupon Code';
  }
  return text;
};

const AdminActionsDropdown = ({
  editBool,
  attendeeEditingKey,
  copyBool,
  viewBool = false,
  handleView,
  statusBool,
  deleteBool,
  saveBool,
  record,
  handleEditClick,
  handleCopyClick,
  usedForTable,
  handleDeleteClick,
  handleSaveClick,
  handleUpdateStatusClick,
  handleUpdateWillReceiveClick,
  willReceiveUpdateBool,
  handleCancelClick,
  eventNavigate = false,
  couponCodeNavigate = false,
  duplicateCouponBool = false,
  handleDuplicateCouponClick,
  sendRecordinEdit,
  text = '',
  usedForAttendeeTable = false,
  handleEditTemplate,
  handleEditSchedule,
  sendDirectEmail,
  handleSendDirectEmailClick,
  viewEventEmailTemplateScheduler,
  handleViewEventEmailTemplateScheduler,
  cancelBool = true,
  ToolTipTitle,
  usedForAdminSide = false,
  usedForAdsAndJobsCart = false,
  setIsAddAttendee,
  setDisableAttendeeClicks,
  setDisablePaymentClicks,
  disableEditClicks = false,
  disableSaveClicks = false,
  saveLoading = false,
  setDisableEditClicks,
  resource,
  chapterContentBool,
  onClickChapterContent,
  sponsorshipInfoBool,
  addNoteBool,
  handleAddNoteClick,
  registrationHistoryBool,
  handleRegistrationHistoryClick,
  creditHistoryBool,
  handleCreditHistoryClick,
  customActionBool,
  handleCustomActionClick,
  customActionLabel = 'Custom Action',
  vendorRepsViewBool = false,
  handleVendorRepsViewClick,
  receiptBool = false,
  handleReceiptClick,
  qualificationFormBool = false,
  handleQualificationFormClick,
  waitingListActionsBool = false,
  handleMoveToRegistrationClick,
  handleCancelWaitingListClick,
  waitingListActionsDisabled = false,
  dropdownDisabled = false,
  localChapterData,
}) => {
  const navigate = useNavigate();
  const {ApplicationString} = useLocalization();
  const toolTipTitle =
    ApplicationString['adminActionsDropdownComponent.toolTipTitle'] ||
    ToolTipTitle;
  const isEditing = (record) =>
    attendeeEditingKey != null &&
    String(record.id) === String(attendeeEditingKey);
  const editable = isEditing(record);

  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const userRole = userInfo?.role;
  const {checkPermission} = usePermissions(userRole);

  const showAuditLog =
    !usedForAttendeeTable && AUDIT_LOG_RESOURCES.has(resource);
  const auditLogText = getAuditLogText(resource, text);

  const setActionAccessible = useCallback((permission) => {
    if (!checkPermission(resource, permission)) {
      return false;
    }
    return true;
  }, []);

  return (
    <>
      {usedForAttendeeTable ? (
        <>
          {editable ? (
            <span
              className={
                usedForAdsAndJobsCart
                  ? 'saveAndCancelWrapperForAds'
                  : 'saveAndCancelWrapperForAttendees'
              }>
              <Tooltip
                title={`${ApplicationString['adminActionsDropdownComponent.saveText']} ${toolTipTitle}`}>
                <Button
                  id={`${text}-action-save-attendee-${record.id}`}
                  prefixCls={
                    usedForAdminSide ? 'admin-save-attendees' : 'attendees-save'
                  }
                  type='link'
                  disabled={disableSaveClicks || saveLoading}
                  onClick={(event) => {
                    if (disableSaveClicks || saveLoading) {
                      event.preventDefault();
                      return;
                    }
                    handleSaveClick(record, event);
                  }}>
                  <span
                    className={`saveAndCancelLink${
                      saveLoading ? ' save-attendee-button-loading' : ''
                    }`}>
                    {saveLoading ? <Spin size='small' /> : null}
                    {
                      ApplicationString[
                        `adminActionsDropdownComponent.saveText`
                      ]
                    }
                  </span>
                </Button>
              </Tooltip>
              {cancelBool && (
                <Tooltip
                  title={`${ApplicationString['adminActionsDropdownComponent.cancelText']} ${toolTipTitle}`}>
                  <Button
                    id={`${text}-action-cancel-attendee-${record.id}`}
                    prefixCls='attendees-close'
                    type='link'
                    disabled={disableSaveClicks}
                    onClick={handleCancelClick}>
                    <span className='saveAndCancelLink'>
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.cancelText`
                        ]
                      }
                    </span>
                  </Button>
                </Tooltip>
              )}
            </span>
          ) : resource === 'events_registrations' &&
            (addNoteBool ||
              viewBool ||
              customActionBool ||
              vendorRepsViewBool ||
              receiptBool ||
              qualificationFormBool) ? (
            <ViewportDropdown
              menu={{
                items: [
                  setActionAccessible(UPDATE) &&
                    editBool && {
                      key: 'edit-registration',
                      label: (
                        <div
                          className='action-container'
                          onClick={() => {
                            setIsAddAttendee && setIsAddAttendee(true);
                            setDisableEditClicks && setDisableEditClicks(true);
                            setDisableAttendeeClicks &&
                              setDisableAttendeeClicks(true);
                            setDisablePaymentClicks &&
                              setDisablePaymentClicks(true);
                            handleEditClick(record);
                          }}>
                          <div className='icon-container edit'>
                            <EditOutlined />
                            {
                              ApplicationString[
                                `adminActionsDropdownComponent.editText`
                              ]
                            }{' '}
                            {text}
                          </div>
                        </div>
                      ),
                    },
                  addNoteBool &&
                    setActionAccessible(UPDATE) && {
                      key: 'add-note',
                      label: (
                        <div
                          className='action-container'
                          onClick={() => handleAddNoteClick(record)}>
                          <div className='icon-container edit'>
                            <FormOutlined />
                            {record?.note
                              ? ApplicationString['addNoteModal.editNote']
                              : ApplicationString['addNoteModal.addNote']}
                          </div>
                        </div>
                      ),
                    },
                  viewBool &&
                    setActionAccessible(READ) && {
                      key: 'view-registration',
                      label: (
                        <div
                          className='action-container'
                          onClick={() => handleView(record)}>
                          <div className='icon-container edit'>
                            <EyeOutlined />
                            {
                              ApplicationString[
                                `adminActionsDropdownComponent.viewText`
                              ]
                            }{' '}
                            {text}
                          </div>
                        </div>
                      ),
                    },
                  vendorRepsViewBool &&
                    setActionAccessible(READ) && {
                      key: 'view-vendor-reps',
                      label: (
                        <div
                          className='action-container'
                          onClick={() =>
                            handleVendorRepsViewClick &&
                            handleVendorRepsViewClick(record)
                          }>
                          <div className='icon-container edit'>
                            <TeamOutlined />
                            View Vendor Reps Details
                          </div>
                        </div>
                      ),
                    },
                  customActionBool &&
                    setActionAccessible(UPDATE) && {
                      key: 'custom-action',
                      label: (
                        <div
                          className='action-container'
                          onClick={() => handleCustomActionClick(record)}>
                          <div className='icon-container edit'>
                            <UploadOutlined />
                            {customActionLabel}
                          </div>
                        </div>
                      ),
                    },
                  receiptBool &&
                    setActionAccessible(READ) && {
                      key: 'download-receipt',
                      label: (
                        <div
                          className='action-container'
                          onClick={() =>
                            handleReceiptClick && handleReceiptClick(record)
                          }>
                          <div className='icon-container edit'>
                            <FileTextOutlined />
                            Download Receipt
                          </div>
                        </div>
                      ),
                    },
                  qualificationFormBool &&
                    setActionAccessible(READ) && {
                      key: 'view-qualification-form',
                      label: (
                        <div
                          className='action-container'
                          onClick={() =>
                            handleQualificationFormClick &&
                            handleQualificationFormClick(record)
                          }>
                          <div className='icon-container edit'>
                            <FileTextOutlined />
                            View Qualification Form
                          </div>
                        </div>
                      ),
                    },
                  deleteBool &&
                    setActionAccessible(DELETE) && {
                      key: 'delete-registration',
                      label: (
                        <Popconfirm
                          title={`${ApplicationString[
                            'adminActionsDropdownComponent.deleteConfirmTitle'
                          ](text)}`}
                          description={`${ApplicationString['adminActionsDropdownComponent.deleteConfirmDescription']}`}
                          onConfirm={() => {
                            handleDeleteClick(record.id);
                          }}
                          okText={`${ApplicationString['adminActionsDropdownComponent.deleteConfirmOkText']}`}
                          cancelText={`${ApplicationString['adminActionsDropdownComponent.deleteConfirmCancelText']}`}
                          okType='danger'
                          icon={
                            <QuestionCircleOutlined
                              style={{
                                color: 'red',
                              }}
                            />
                          }>
                          <div className='action-container'>
                            <div className='icon-container delete'>
                              <DeleteOutlined />
                              {
                                ApplicationString[
                                  `adminActionsDropdownComponent.deleteText`
                                ]
                              }{' '}
                              {text}
                            </div>
                          </div>
                        </Popconfirm>
                      ),
                    },
                  {
                    key: 'audit-log-registration',
                    label: (
                      <div className='action-container'>
                        <div className='icon-container edit'>
                          <AuditLogModalTrigger
                            userInfo={record}
                            text='Event Registration'
                            showIcon={false}
                            buttonProps={{
                              type: 'text',
                              style: {
                                color: 'inherit',
                                padding: 0,
                                height: 'auto',
                              },
                            }}
                          />
                        </div>
                      </div>
                    ),
                  },
                ].filter(Boolean),
              }}
              trigger={['click']}>
              <span className='adminActionsDropdown'>
                <span className='adminActionsDropdown2'>
                  <svg
                    width='20px'
                    height='20px'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <circle cx='12' cy='4' r='2' fill='#000' />
                    <circle cx='12' cy='12' r='2' fill='#000' />
                    <circle cx='12' cy='20' r='2' fill='#000' />
                  </svg>
                </span>
              </span>
            </ViewportDropdown>
          ) : (
            <span
              className={
                usedForAdsAndJobsCart
                  ? 'saveAndCancelWrapperForAds'
                  : 'saveAndCancelWrapperForAttendees'
              }>
              {setActionAccessible(UPDATE) && editBool && (
                <Tooltip
                  title={`${ApplicationString['adminActionsDropdownComponent.editText']} ${toolTipTitle}`}>
                  <Button
                    id={`${text}-action-edit-attendee-${record.id}`}
                    prefixCls={
                      usedForAdminSide
                        ? 'admin-save-attendees'
                        : 'attendees-save'
                    }
                    type='link'
                    disabled={disableEditClicks}
                    onClick={() => {
                      setIsAddAttendee && setIsAddAttendee(true);
                      setDisableEditClicks && setDisableEditClicks(true);
                      setDisableAttendeeClicks &&
                        setDisableAttendeeClicks(true);
                      setDisablePaymentClicks && setDisablePaymentClicks(true);
                      handleEditClick(record);
                    }}>
                    <span className='saveAndCancelLink'>
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.editText`
                        ]
                      }
                    </span>
                  </Button>
                </Tooltip>
              )}
              {deleteBool && setActionAccessible(DELETE) && (
                <Tooltip
                  title={`${ApplicationString['adminActionsDropdownComponent.deleteText']} ${toolTipTitle}`}>
                  <Popconfirm
                    title={`${ApplicationString[
                      'adminActionsDropdownComponent.deleteConfirmTitle'
                    ](text)}`}
                    description={`${ApplicationString['adminActionsDropdownComponent.deleteConfirmDescription']}`}
                    onConfirm={() => {
                      handleDeleteClick(record.id);
                    }}
                    disabled={disableEditClicks}
                    okText={`${ApplicationString['adminActionsDropdownComponent.deleteConfirmOkText']}`}
                    cancelText={`${ApplicationString['adminActionsDropdownComponent.deleteConfirmCancelText']}`}
                    okType='danger'
                    icon={
                      <QuestionCircleOutlined
                        style={{
                          color: 'red',
                        }}
                      />
                    }>
                    <Button
                      id={`${text}-action-delete-attendee-${record.id}`}
                      prefixCls='attendees-close'
                      type='link'
                      disabled={disableEditClicks}>
                      {' '}
                      <span className='saveAndCancelLink'>
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.deleteText`
                          ]
                        }{' '}
                      </span>
                    </Button>
                  </Popconfirm>
                </Tooltip>
              )}
            </span>
          )}
        </>
      ) : (
        <ViewportDropdown
          disabled={dropdownDisabled}
          menu={{
            items: [
              waitingListActionsBool &&
                setActionAccessible(UPDATE) && {
                  key: 'waiting-list-move',
                  disabled: waitingListActionsDisabled,
                  label: (
                    <Popconfirm
                      title={
                        ApplicationString[
                          'waitingList.moveToRegistration.confirmTitle'
                        ] || 'Move to Event Registration'
                      }
                      description={
                        ApplicationString[
                          'waitingList.moveToRegistration.confirmDescription'
                        ]
                      }
                      onConfirm={() => handleMoveToRegistrationClick(record.id)}
                      okText='Yes'
                      cancelText='No'
                      okType='primary'
                      disabled={waitingListActionsDisabled}
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: 'warning',
                          }}
                        />
                      }>
                      <div
                        className='action-container'
                        id={`waitingList-moveToRegistration-${record.id}`}>
                        <div className='icon-container edit'>
                          <ExportOutlined />
                          {ApplicationString[
                            'waitingList.moveToRegistration'
                          ] || 'Move to Event Registration'}
                        </div>
                      </div>
                    </Popconfirm>
                  ),
                },
              waitingListActionsBool &&
                setActionAccessible(UPDATE) && {
                  key: 'waiting-list-cancel',
                  disabled: waitingListActionsDisabled,
                  label: (
                    <Popconfirm
                      title={
                        ApplicationString[
                          'waitingList.cancelEntry.confirmTitle'
                        ] || 'Cancel Waiting List Entry'
                      }
                      description={
                        ApplicationString[
                          'waitingList.cancelEntry.confirmDescription'
                        ]
                      }
                      onConfirm={() => handleCancelWaitingListClick(record.id)}
                      okText='Yes'
                      cancelText='No'
                      okType='danger'
                      disabled={waitingListActionsDisabled}
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: 'red',
                          }}
                        />
                      }>
                      <div
                        className='action-container'
                        id={`waitingList-cancelEntry-${record.id}`}>
                        <div className='icon-container delete'>
                          <DeleteOutlined />
                          {ApplicationString['waitingList.cancelEntry'] ||
                            'Cancel Entry'}
                        </div>
                      </div>
                    </Popconfirm>
                  ),
                },
              editBool &&
                setActionAccessible(UPDATE) && {
                  key: 1,
                  label: (
                    <div
                      className='action-container'
                      onClick={() => {
                        handleEditClick(sendRecordinEdit ? record : record.id);
                      }}
                      id={`${text}-action-edit-${record.id}`}>
                      <div className='icon-container edit'>
                        <EditOutlined />
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.editText`
                          ]
                        }{' '}
                        {text}
                      </div>
                    </div>
                  ),
                },
              chapterContentBool && {
                key: 14,
                label: (
                  <div
                    className='action-container'
                    onClick={() => {
                      onClickChapterContent(record);
                    }}
                    id={`${text}-action-create-${record.id}`}>
                    <div className='icon-container edit'>
                      <EditOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.addEditChapterContent`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              sponsorshipInfoBool && {
                key: 15,
                label: (
                  <div
                    className='action-container'
                    onClick={() => {
                      navigate(`/admin/sponsorshipInfo/${record?.id}`);
                    }}
                    id={`${text}-action-create-${record.id}`}>
                    <div className='icon-container edit'>
                      <EditOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.editSponsorshipInfo`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              registrationHistoryBool && {
                key: 'registration-history',
                label: (
                  <div
                    className='action-container'
                    onClick={() => handleRegistrationHistoryClick(record)}
                    id={`${text}-action-registration-history-${record.id}`}>
                    <div className='icon-container edit'>
                      <ExportOutlined />
                      Registrations / Receipts
                    </div>
                  </div>
                ),
              },
              creditHistoryBool && {
                key: 'credit-history',
                disabled: !record?.has_credit_history,
                label: !record?.has_credit_history ? (
                  <Tooltip title='No credit history'>
                    <div
                      className='action-container'
                      id={`${text}-action-credit-history-${record.id}`}>
                      <div className='icon-container edit'>
                        <EyeOutlined />
                        View Credit History
                      </div>
                    </div>
                  </Tooltip>
                ) : (
                  <div
                    className='action-container'
                    onClick={() => handleCreditHistoryClick(record)}
                    id={`${text}-action-credit-history-${record.id}`}>
                    <div className='icon-container edit'>
                      <EyeOutlined />
                      View Credit History
                    </div>
                  </div>
                ),
              },
              viewBool &&
                setActionAccessible(READ) && {
                  key: 'view-record',
                  label: (
                    <div
                      onClick={() => handleView(record)}
                      id={`${text}-action-copy-${record.id}`}
                      className='icon-container edit'>
                      <EyeOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.viewText`
                        ]
                      }{' '}
                      {text}
                    </div>
                  ),
                },
              copyBool &&
                setActionAccessible('copy') && {
                  key: 2,
                  label: (
                    <Popconfirm
                      title='Duplicate the event'
                      prefixCls='status-modal-popconfirm'
                      description='Are you sure you want to duplicate?'
                      onConfirm={() => handleCopyClick(record.id)}
                      okText='Yes'
                      cancelText='No'
                      okType='primary'
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: 'warning',
                          }}
                        />
                      }>
                      <div
                        id={`${text}-action-copy-${record.id}`}
                        className='icon-container edit'>
                        <CopyOutlined />
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.copyText`
                          ]
                        }{' '}
                        {text}
                      </div>
                    </Popconfirm>
                  ),
                },
              handleEditTemplate && {
                key: 11,
                label: (
                  // <Tooltip prefixCls = 'common-pbss-tooltip' title='Click here to edit your data!'>
                  <div
                    className='action-container'
                    onClick={() => {
                      handleEditTemplate(true, record.id);
                    }}
                    id={`eventsGroupComponent-action-edit-${record.id}`}>
                    <div className='icon-container edit'>
                      <EditOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.editEmailTemplate`
                        ]
                      }
                    </div>
                  </div>
                  // </Tooltip>
                ),
              },
              handleEditSchedule && {
                key: 12,
                label: (
                  // <Tooltip prefixCls = 'common-pbss-tooltip' title='Click here to edit your data!'>
                  <div
                    className='action-container'
                    onClick={() => {
                      handleEditSchedule(false, record.id);
                    }}
                    id={`eventsGroupComponent-action-edit-${record.id}`}>
                    <div className='icon-container edit'>
                      <EditOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.editScheduleOfTemplate`
                        ]
                      }
                    </div>
                  </div>
                  // </Tooltip>
                ),
              },
              sendDirectEmail && {
                key: 13,
                label: (
                  <Popconfirm
                    title={
                      ApplicationString[
                        'adminActionsDropdownComponent.sendDirectEmailConfirmTitle'
                      ]
                    }
                    description={
                      ApplicationString[
                        'adminActionsDropdownComponent.sendDirectEmailConfirmDescription'
                      ]
                    }
                    onConfirm={() => {
                      Modal.confirm({
                        prefixCls: 'event-form-want-to-leave-popup',
                        title:
                          ApplicationString[
                            'adminActionsDropdownComponent.sendDirectEmailConfirmTitle'
                          ],
                        content:
                          ApplicationString[
                            'adminActionsDropdownComponent.sendDirectEmailSecondConfirmDescription'
                          ],
                        okText: 'Yes',
                        cancelText: 'Cancel',
                        centered: true,
                        closable: true,
                        icon: null,
                        zIndex: 2000,
                        okButtonProps: {
                          style: {
                            backgroundColor: 'var(--PBSS--Primary)',
                            borderColor: 'var(--PBSS--Primary)',
                          },
                        },
                        cancelButtonProps: {
                          className: 'common-cancel-button',
                        },
                        onOk: () => handleSendDirectEmailClick(record.id),
                      });
                    }}
                    okText='Yes'
                    cancelText='No'
                    okType='primary'
                    icon={
                      <QuestionCircleOutlined
                        style={{
                          color: 'warning',
                        }}
                      />
                    }>
                    <div
                      className='action-container'
                      id={`eventsGroupComponent-action-edit-${record.id}`}>
                      <div className='icon-container edit'>
                        <SendOutlined />
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.sendDirectEmail`
                          ]
                        }
                      </div>
                    </div>
                  </Popconfirm>
                ),
              },
              viewEventEmailTemplateScheduler &&
                handleViewEventEmailTemplateScheduler && {
                  key: 16,
                  label: (
                    <div
                      className='action-container'
                      onClick={() => {
                        handleViewEventEmailTemplateScheduler(record);
                      }}
                      id={`${text}-action-view-scheduler-${record.id}`}>
                      <div className='icon-container edit'>
                        <EyeOutlined />
                        Preview Event Email Template Scheduler
                      </div>
                    </div>
                  ),
                },
              deleteBool &&
                setActionAccessible(DELETE) && {
                  key: 3,
                  label: (
                    <Popconfirm
                      title={`Delete the ${text}`}
                      description='Are you sure you want to delete?'
                      onConfirm={() => handleDeleteClick(record.id)}
                      okText='Yes'
                      cancelText='No'
                      okType='danger'
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: 'red',
                          }}
                        />
                      }>
                      <div
                        className='action-container'
                        id={`${text}-action-delete-${record.id}`}>
                        <div className='icon-container delete'>
                          <DeleteOutlined />
                          {
                            ApplicationString[
                              `adminActionsDropdownComponent.deleteText`
                            ]
                          }{' '}
                          {text}
                        </div>
                      </div>
                    </Popconfirm>
                  ),
                },
              statusBool &&
                setActionAccessible('status') && {
                  key: 4,
                  label: (
                    <div
                      className='action-container'
                      onClick={() => handleUpdateStatusClick(record)}
                      id={`${text}-action-status-${record.id}`}>
                      <div className='icon-container status'>
                        <FormOutlined />
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.changeStatusText.part1`
                          ]
                        }{' '}
                        {text}{' '}
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.changeStatusText.part2`
                          ]
                        }
                      </div>
                    </div>
                  ),
                },
              willReceiveUpdateBool &&
                handleUpdateWillReceiveClick &&
                setActionAccessible('status') && {
                  key: 17,
                  label: (
                    <div
                      className='action-container'
                      onClick={() => handleUpdateWillReceiveClick(record)}
                      id={`${text}-action-will-receive-${record.id}`}>
                      <div className='icon-container status'>
                        <FormOutlined />
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.changeWillReceiveText.part1`
                          ]
                        }{' '}
                        {text}{' '}
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.changeWillReceiveText.part2`
                          ]
                        }
                      </div>
                    </div>
                  ),
                },
              eventNavigate && {
                key: 5,
                label: (
                  <div
                    className='action-container'
                    onClick={() =>
                      navigate(`/admin/eventRegistration/${record?.id}`)
                    }>
                    <div
                      className='icon-container'
                      id={`${text}-action-registration-${record.id}`}>
                      <ExportOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.eventRegistration`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              eventNavigate && {
                key: 14,
                label: (
                  <div
                    className='action-container'
                    onClick={() => navigate(`/admin/waitingList/${record.id}`)}>
                    <div
                      className='icon-container'
                      id={`${text}-action-registration-${record.id}`}>
                      <ExportOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.eventRegistrationWaitingList`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              eventNavigate && {
                key: 6,
                label: (
                  <div
                    className='action-container'
                    onClick={() =>
                      navigate(
                        `/admin/${/*record.id/*/ ''}eventOptions/${record?.id}`,
                      )
                    }>
                    <div
                      className='icon-container'
                      id={`${text}-action-options-${record.id}`}>
                      <ExportOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.eventOptions`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              eventNavigate && {
                key: 7,
                label: (
                  <div
                    className='action-container'
                    onClick={() =>
                      navigate(
                        `/admin/eventEmailTemplatesScheduler/${record?.id}`,
                      )
                    }>
                    <div
                      className='icon-container'
                      id={`${text}-action-schedular-${record.id}`}>
                      <ExportOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.eventEmailScheduler`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              eventNavigate && {
                key: 8,
                label: (
                  <div
                    className='action-container'
                    onClick={() =>
                      navigate(`/admin/eventRefund/${record?.id}`)
                    }>
                    <div
                      className='icon-container'
                      id={`${text}-action-refund-${record.id}`}>
                      <ExportOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.eventRefund`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              !usedForAttendeeTable &&
                !waitingListActionsBool && {
                  key: 9,
                  label: (
                    <div className='action-container'>
                      <div
                        className='icon-container'
                        id={`History-${record.id}`}>
                        <UpdateHistoryTableInfo
                          userInfo={record}
                          hideBool={true}
                          text={eventNavigate ? '' : text}
                        />
                      </div>
                    </div>
                  ),
                },
              !usedForAttendeeTable &&
                showAuditLog && {
                  key: 'audit-log',
                  label: (
                    <div className='action-container'>
                      <div className='icon-container edit'>
                        <AuditLogModalTrigger
                          userInfo={record}
                          text={auditLogText}
                          localChapterData={localChapterData}
                          showIcon={false}
                          buttonProps={{
                            type: 'text',
                            style: {
                              color: 'inherit',
                              padding: 0,
                              height: 'auto',
                            },
                          }}
                        />
                      </div>
                    </div>
                  ),
                },
              usedForTable &&
                !waitingListActionsBool && {
                  key: 9,
                  label: (
                    <div className='action-container'>
                      <div className='icon-container'>
                        <UpdateHistoryTableInfo
                          userInfo={record}
                          hideBool={true}
                          text={eventNavigate ? '' : text}
                        />
                      </div>
                    </div>
                  ),
                },
              usedForTable &&
                showAuditLog && {
                  key: 'audit-log-table',
                  label: (
                    <div className='action-container'>
                      <div className='icon-container edit'>
                        <AuditLogModalTrigger
                          userInfo={record}
                          text={auditLogText}
                          localChapterData={localChapterData}
                          showIcon={false}
                          buttonProps={{
                            type: 'text',
                            style: {
                              color: 'inherit',
                              padding: 0,
                              height: 'auto',
                            },
                          }}
                        />
                      </div>
                    </div>
                  ),
                },
              couponCodeNavigate && {
                key: 'coupon-users',
                label: (
                  <div
                    className='action-container'
                    onClick={() =>
                      navigate(`/admin/couponCodes/users/${record?.code}`)
                    }>
                    <div
                      className='icon-container'
                      id={`${text}-action-refund-${record.id}`}>
                      <EyeOutlined />
                      {
                        ApplicationString[
                          `adminActionsDropdownComponent.viewCouponUsers`
                        ]
                      }
                    </div>
                  </div>
                ),
              },
              duplicateCouponBool &&
                setActionAccessible(CREATE) && {
                  key: 'duplicate-coupon',
                  label: (
                    <div
                      className='action-container'
                      onClick={() => handleDuplicateCouponClick(record.id)}>
                      <div
                        className='icon-container edit'
                        id={`${text}-action-duplicate-${record.id}`}>
                        <CopyOutlined />
                        Duplicate coupon
                      </div>
                    </div>
                  ),
                },
              saveBool && {
                key: 10,
                label: (
                  <Tooltip
                    className='common-pbss-tooltip'
                    title='Click here to save your data!'>
                    <div
                      className='action-container'
                      onClick={() => handleSaveClick(record)}
                      id={`eventsGroupComponent-action-save-${record.id}`}>
                      <div className='icon-container edit'>
                        <SaveOutlined />
                        {
                          ApplicationString[
                            `adminActionsDropdownComponent.saveText`
                          ]
                        }
                        {text}
                      </div>
                    </div>
                  </Tooltip>
                ),
              },
            ],
          }}
          trigger={['click']}>
          <span
            className={`adminActionsDropdown${
              dropdownDisabled ? ' adminActionsDropdown--disabled' : ''
            }`}>
            <span className='adminActionsDropdown2'>
              <svg
                width='20px'
                height='20px'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <circle cx='12' cy='4' r='2' fill='#000' />
                <circle cx='12' cy='12' r='2' fill='#000' />
                <circle cx='12' cy='20' r='2' fill='#000' />
              </svg>
            </span>
          </span>
        </ViewportDropdown>
      )}

      {addNoteBool && resource !== 'events_registrations' && (
        <span className={'saveAndCancelWrapperForAttendees'}>
          {setActionAccessible(UPDATE) && editBool && (
            <Tooltip title={`Add Note`}>
              <Button
                id={`${text}-action-add-note-${record.id}`}
                type='link'
                style={{color: '#005d61'}}
                onClick={() => handleAddNoteClick(record)}>
                <span className='saveAndCancelLink'>
                  {' '}
                  {record?.note
                    ? ApplicationString['addNoteModal.editNote']
                    : ApplicationString['addNoteModal.addNote']}
                </span>
              </Button>
            </Tooltip>
          )}
          {resource === 'events_registrations' && (
            <AuditLogModalTrigger
              userInfo={record}
              text='Event Registration'
              showIcon={false}
            />
          )}
        </span>
      )}
    </>
  );
};

export default AdminActionsDropdown;
